"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TreesEvergreenSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M21.78 2.988a1.5 1.5 0 0 1 2.44 0l4.03 5.64c.708.993-.002 2.372-1.221 2.372h-.16l2.445 3.668c.664.997-.05 2.332-1.248 2.332h-.448l1.915 3.83A1.5 1.5 0 0 1 28.19 23H24v5h5a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h5v-2H3.81a1.5 1.5 0 0 1-1.343-2.17l1.951-3.902a1.502 1.502 0 0 1-.821-2.2l1.716-2.86c-.798-.36-1.166-1.392-.627-2.2l3.066-4.599a1.5 1.5 0 0 1 2.496 0l3.066 4.599c.539.808.17 1.84-.627 2.2l1.716 2.86a1.502 1.502 0 0 1-.82 2.2l1.95 3.901A1.5 1.5 0 0 1 14.19 26H10v2h12v-5h-4.19a1.5 1.5 0 0 1-1.343-2.17L18.382 17h-.448c-1.198 0-1.912-1.335-1.248-2.332L19.131 11h-.16c-1.22 0-1.93-1.38-1.22-2.372l4.028-5.64z" stroke="none"></path>';
var TreesEvergreenSVG = function TreesEvergreenSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.TreesEvergreenSVG = TreesEvergreenSVG;
TreesEvergreenSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TreesEvergreenSVG);
exports.default = _default;